import PublicEvent from './PublicEvent.js';

class StopRecordingEvent extends PublicEvent {
  handle(msg) {
    this.context._api.stopRecording(msg);
  }
}

export default StopRecordingEvent;
